"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hashMessage = hashMessage;
exports.messagePrefix = void 0;
var _bytes = require("@ethersproject/bytes");
var _keccak = require("@ethersproject/keccak256");
var _strings = require("@ethersproject/strings");
const messagePrefix = exports.messagePrefix = "\x19Ethereum Signed Message:\n";
function hashMessage(message) {
  if (typeof message === "string") {
    message = (0, _strings.toUtf8Bytes)(message);
  }
  return (0, _keccak.keccak256)((0, _bytes.concat)([(0, _strings.toUtf8Bytes)(messagePrefix), (0, _strings.toUtf8Bytes)(String(message.length)), message]));
}